<template>
    <div>
        <loader v-if="loading"></loader>
        <div v-else>
            <div class="row" v-if="state">
                <div class="col-md-5">
                    <div class="m-3 clearfix">
                        <h5 class="text-success float-left">ONLINE - </h5>
                        <span class="badge badge-primary ml-2 mr-2" :key="service" v-for="service in state.services">{{service}}</span>
                    </div>
                    <div class="m-3">
                        <dl class="row">
                            <dt class="col-sm-4">Vehicle:</dt>
                            <dd class="col-sm-8">{{state.vehicle.model.name}}</dd>
                            <dt class="col-sm-4">Plate: </dt>
                            <dd class="col-sm-8">{{state.vehicle.plate}}</dd>
                            <dt class="col-sm-4">Speed: </dt>
                            <dd class="col-sm-8">{{(Number(state.speed) * 3.6).toFixed(0)}}km/h</dd>
                            <dt class="col-sm-4">Time: </dt>
                            <dd class="col-sm-8">{{state.createdAt}}</dd>
                        </dl>

                        <b-button size="sm" variant="danger" v-b-modal.offline>Set Offline</b-button>
                        <b-modal id="offline" title="Offline Driver" @ok="setOffline">
                            <p class="my-4">Confirmation</p>
                        </b-modal>
                    </div>
                </div>
                <div class="col-md-7">
                    <GmapMap :options="{
                   zoomControl: true,
                   mapTypeControl: false,
                   scaleControl: false,
                   streetViewControl: false,
                   rotateControl: false,
                   fullscreenControl: true,
                   disableDefaultUI: false
                }" :center="{lat:state.location.coordinates[1], lng:state.location.coordinates[0]}" :zoom="14" id="map">
                        <GmapMarker v-if="google" :position="new google.maps.LatLng(state.location.coordinates[1], state.location.coordinates[0])" />
                    </GmapMap>
                </div>
            </div>
            <div v-else>
                <div class="card-body">
                    <h5 class="card-title text-center">Offline</h5>
                    <p class="card-text text-center">
                        Driver Offline
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GetDriverState from '../../../../store/actions/getDriverState';
import OfflineDriver from '../../../../store/actions/offlineDriver';
import ShowError from "../../../../helpers/showError";
import ContentLoader from "../../../../components/ContentLoader";
import {gmapApi} from 'vue2-google-maps'

  export default {
    name: 'DriverStatus',
    components: {
      loader: ContentLoader,
    },
    computed: {
      google: gmapApi
    },
    data() {
      return {
        loading: true,
        state: false
      }
    },
    created() {
      this.load();
    },
    methods: {
      async setOffline(){
        try {
          this.loading = true;
          await OfflineDriver(this.$route.params.id);
          this.load();
        } catch (e) {
          ShowError(this, e);
        }
        finally {
          this.loading = false;
        }
      },
      async load(){
        try {
          this.loading = true;
          this.state = await GetDriverState(this.$route.params.id);
        } catch (e) {
          if(e.response.data['statusCode'] !== 404) {
            ShowError(this, e);
          } else {
            this.state = false;
          }
        } finally {
          this.loading = false;
        }
      }
    }
  }
</script>


<style scoped>
    #map{
        width: 100%;
        height: 350px;
    }
</style>
